<style scoped>
	.plan-card .button[disabled]:hover,
	.plan-card .button.disabled:hover {
		cursor: not-allowed;
	}

	.plan-comparison {
		max-width: calc(50% - .5rem);
	    min-width: calc(50% - .5rem);
	    width: calc(50% - .5rem);
	}

	.plan-comparison .button.disabled {
		/* color: #333; */
		/* opacity: 1; */
	}
	.plan-comparison .button.disabled:hover {
		cursor: default;
	}
	.plan-card {
		max-width: 205px;
		min-height: 268px;
	}
	.dark .plan-card {
		border-color: #333;
	}

	.plan-card .bullet .bullet-margin {
		display: none;
	}
	.plan-comparison .plan-card .bullet .bullet-margin {
		display: block;
	}
	.plan-card .bullet .bullet-content {
		margin-left: 0;
	}
	.plan-cards {
		/* max-width: 1068px; */
	}
	.plan-card > header > h1 {
		margin-top: 0;
	}
	.plan-card > header {
		margin-bottom: 1.5em;
	}
	.plan-features {
		text-align: left;
		margin: 0 0 2rem;
	}
	.plan-features li i:not(.success):not(.error){
		color: #2E88D6;
	}
	.plan-comparison .current-plan .plan-features li i:not(.success):not(.error){
		color: #777;
	}
	.plan-features li .bullet-margin {
		width: 1.5rem;
		text-align: left;
	}
	.plan-features li {
		line-height: 1.4rem;
		margin-bottom: .5rem;
	}
	.review-change .button.success.active + .button.success.active {
		display: none;
	}
	/* .plan-features li:before {
		content: '\f00c';
		font-family: 'Font Awesome 5 Free';
		font-weight: 900;
		margin-right: .5rem;
		color: #2E88D6;
	} */
	.plan-option:first-of-type {
		margin-top: auto;
	}
	.annual.badge {
		position: absolute;
		top: -.5rem;
		right: .5rem;
	}
	.plan-comparison .current-plan:not(.new-plan) .annual.badge {
		display: none;
	}
	.button {
		overflow: visible;
		text-align: center;
	}
	.button.active:before {
		content: '\f00c';
		font-family: 'Font Awesome 5 Free';
		font-weight: 900;
		position: absolute;
		left: 1rem;
	}
 	.button.new.active:before {
		color: #2E88D6;
	}
	.button.success.new.active:before {
		color: #fff;
	}

	h1.total {
		margin: 0;
	}
	h2 {
		line-height: 1.4em;
	}
	.half-width {
		max-width: calc(50% - .5rem);
		min-width: calc(50% - .5rem);
		width: calc(50% - .5rem);
	}
	.cost-summary {
		height: 86px;
		max-width: calc(50% - .5rem);
	    min-width: calc(50% - .5rem);
	    width: calc(50% - .5rem);
	}
	.change-summary {
		padding-right: 5rem;
		width: 50%;
	}
	.change-summary ul,
	.change-summary ul ul {
		list-style-type: none;
	}

	.payment-notice {
		margin: 0;
	}

	section {
		margin-bottom: 2rem;
	}

	footer.row button {
		width: 100%;
	}

	.notice a {
		font-weight: bolder;
	}

	.inactive {
		background: #fafafa;
		cursor: not-allowed;
	}

	.dark .inactive {
		background-color: #222;
	}

	.inactive .badge-muted {
		background-color: #ddd;
	}

	.inactive .badge-muted {
		background-color: #444;
		color: #212121;
	}

	.plan-card:nth-child(n+5) {
		margin-top: 1rem;
		margin-left: 0;
	}

	@media only screen and (max-width : 1120px) {
		.plan-cards {
			width: 100%;
			box-sizing: border-box;
			flex-wrap: wrap;
		}

		.change-summary {
			width: 100%;
			padding-right: 0;
		}

		.row.separated-extra > .plan-comparison {
			min-width: 100%;
			margin-left: 0;
		}

		.review-change {
			flex-direction: column;
		}

		.plan-card {
		    box-sizing: border-box;
		}

		.change-plan-wrapper > header {
			background: white;
			position: sticky;
			top: 0;
			z-index: 2;
			padding: 1rem 0;
			box-sizing: border-box;
		}
		.dark .change-plan-wrapper > header {
			background: #1a1a1a;
		}
	}

	@media (min-width : 600px) and (max-width : 1120px) {
		.plan-card {
			min-width: calc(50% - .5rem);
			max-width: calc(50% - .5rem);
		    box-sizing: border-box;
			margin-left: 0;
		}

		.plan-card:nth-child(even) {
			margin-left: 1rem;
		}

		.plan-card:nth-child(odd) {
			margin-left: 0;
		}

		.plan-card:nth-child(n+3) {
			margin-top: 1rem;
		}
	}

	@media only screen and (max-width : 599px) {
		.change-plan-wrapper > header.row {
			flex-direction: column;
		}

		.row.separated .flexible.cost-summary {
			min-width: 100%;
			margin-left: 0;
		}
		.plan-cards {
			flex-direction: column;
		}

		.plan-card {
			max-width: 100%;
		}

		.plan-card + .plan-card {
			margin-top: 1rem;
			margin-left: 0;
		}

		.review-change footer.row {
			flex-direction: column-reverse;
		}

		.review-change footer.row button + button {
			margin-left: 0;
			margin-bottom: 1rem;
		}
	}

	@media only screen and (max-width : 415px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

	@media only screen and (min-width : 600px) and (max-width : 775px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

</style>

<template>
	<form class="column flexible detail-page content content-1100 drive" @submit.prevent="onSubmitPlan">
		<header class="column">
			<div class="row centering separated">
				<!-- <router-link title="Go to Account Home" class="rigid" @click="resetState" to="/"><i class="fas fa-arrow-left"></i></router-link> -->
				<button class="link" title="Go to Account Home" @click="leavePlan" type="button" name="button"><i class="fas fa-arrow-left"></i></button>
				<h1-placeholder :text="'TekDrive Subscription'" v-if="subscriptionLoading"></h1-placeholder>
				<h1 class="gap" v-else>
					<span v-if="showOnboardingFlow">Setup your</span>
					<span v-else>Your</span>
					TekDrive Subscription
				</h1>
			</div>
		</header>

		<div v-if="redirectReason">
			<p v-if="redirectReason === 'expired'" class="notice warn subscription-expired">
				Your subscription has expired. Select a new subscription below to continue using this account.
			</p>
		</div>

		<div class="column change-plan-wrapper">
			<header class="row rigid separated centering">
				<div v-if="subscriptionLoading" class="flexible row separated-extra baseline">
					<h2-placeholder :text="'Your Plan'"></h2-placeholder>
				</div>
				<div v-else class="flexible row separated-extra baseline">
					<h2 class="rigid" :class="{muted: newPlan}">1. Choose a Plan</h2>
					<h2 class="rigid" :class="{muted: !newPlan}">2. Review</h2>
				</div>
				<!-- free summary
				paid summary
				free trial summary  -->
				<div :class="{invisible:subscriptionLoading || !selectionId}" class="flexible card card-secondary row centering cost-summary">
					<div class="row flexible centering" v-if="selectionId">
						<div class="column separated flexible">
							<h4 class="flexible">
								<span v-if="selectionCost">
									<span v-if="newPlan">Due now</span>
									<span v-else-if="current.renews">Next charge on {{current && current.expiry | date}}</span>
									<span v-else>
										Ends on {{current && current.expiry | date}}
									</span>
								</span>
								<span v-else-if="selection && selection.hasTrial">Ends in {{TRIAL_DAYS}} Days</span>
								<span v-else>No upcoming charges</span>
							</h4>
							<small v-if="selection && selection.id" class="gray-6 rigid">
								<span v-if="selection.hasTrial || selection.isTrial">Won't auto-renew</span>
								<span v-else-if="selectionCost" :class="{'invisible':!paymentMethodLoaded}">
									<span class="row centering separated" v-if="account.paymentMethod">
										<toggle-switch tabindex="0" @change="onRenewalChange" v-model="subRenews" :disabled="submitting"></toggle-switch>
										<span class="rigid">Auto-renews</span>
										<span class="rigid" v-if="toggling"><i class="fas fa-spinner fa-spin"></i></span>
									</span>
									<router-link to="/payments/method?returnPath=%2Fsubscriptions%2Fdrive" v-else>Add a card to auto-renew</router-link>
								</span>
								<span v-else-if="selectionCost" class="rigid">Auto-renews</span>
								<span v-else>Never ends</span>
							</small>
						</div>
						<div class="column rigid">
							<h1 class="total rigid">
								<strong v-if="selectionCost">{{selectionCost | currency(true)}}</strong>
								<strong v-else>Free</strong>
							</h1>
							<small v-if="selectionCost" class="gray-6 text-right">Plus tax</small>
						</div>
					</div>
				</div>
			</header>

			<plan-card-placeholder v-if="!currentPlan && subscriptionLoading" :items="4"></plan-card-placeholder>

			<div v-if="current && current.expires && !newPlan" class="notice notice-info">
				Your current subscription will not renew automatically. To continue service, please choose a new plan below.
			</div>

			<!-- paid plan options -->
			<div class="row rigid separated-extra review-change">
				<div v-if="newPlan" class="change-summary">
					<!-- free trial flow -->
					<ul v-if="newTrial" class="column">
						<li class="rigid">
							<h2>You’ve chosen <em>{{newPlan.name}} free trial</em>.
							</h2>
						</li>
						<li class="rigid">
							<h2>What happens after my trial ends?</h2>
							<ul class="bullets">
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">You will not be charged.</div>
								</li>
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">If you have an existing subscription, it will resume automatically. Otherwise, your subscription will change to the free <em>Basic</em> plan.
									</div>
								</li>
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">If you'd like to subscribe to <em>{{newPlan.name}}</em>, you can purchase by credit card or purchase order. <a href="mailto:support@support.tekcloud.com">Contact support</a> for more information.
									</div>
								</li>
							</ul>
						</li>
					</ul>
					<!-- onboarding flow -->
					<ul v-else-if="onboardingPlan" class="column">
						<li class="rigid">
							<h2>You’ve chosen <em>{{onboardingPlan.name}} {{onboardingPlan.interval}}</em>.</h2>
						</li>
						<li class="rigid">
							<h2>What happens next?</h2>
							<ul class="bullets">
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">Your new plan will start now and renew {{onboardingPlan.interval}}.</div>
								</li>
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">You can change your plan at anytime. See <a target="_blank" href="https://dev-www.tekcloud.com/terms">Terms of Use</a>.</div>
								</li>
							</ul>
						</li>
					</ul>
					<!-- change plan flow -->
					<ul v-else-if="currentPlanCopy" class="column">
						<li class="rigid">
							<h2>You’re switching from
								<em>{{currentPlanCopy.name}} <span v-if="currentPlanCopy.amount">{{currentPlanCopy.interval}}</span></em> to
								<em>{{newPlan.name}}
									<span v-if="newPlan.amount">{{newPlan.interval}}</span>
									<span v-else-if="newPlan.hasTrial">free trial</span>
								</em>.
							</h2>
						</li>
						<li class="rigid">
							<h2>What happens next?</h2>
							<ul class="bullets">
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">Your new plan will start now.</div>
								</li>
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">We’ll apply any unused credit from your current plan to your new plan. See <a target="_blank" href="https://dev-www.tekcloud.com/terms">Terms of Use</a>.</div>
								</li>
							</ul>
						</li>
					</ul>
				</div>

				<div class="column separated-extra flexible" :class="{'plan-comparison' : newPlan}">
					<section class="rigid row plan-cards" :class="{'flowing' : plans.length > 4}">
						<div class="plan-card" v-for="(plan, index) in plans" v-bind:key="index" :class="{'current-plan': plan.name === currentPlanName, 'new-plan': plan.name === newPlanName, 'inactive': !plan.active}">
							<header class="row separated">
								<h1 class="plan-title rigid">{{plan.name}}</h1>
								<span v-if="plan.name === currentPlanName" class="badge badge-muted rigid">Current</span>
								<span v-else-if="newTrial" class="badge badge-mono badge-success rigid">Trial</span>
								<span v-else-if="plan.name === newPlanName" class="badge badge-mono badge-info rigid">New</span>
							</header>
							<ul v-if="isNewPlan(plan)" class="plan-features">
								<li v-if="plan.details.storageSizeLimit" class="bullet">
									<div class="bullet-margin"><i class="fas" :class="getNumberIconClass(newPlan, currentPlanCopy)"></i></div>
									<div class="bullet-content">{{newPlan.details.storageSizeLimit.displayValue}}</div>
								</li>
								<li v-if="plan.details.sharingType" class="bullet">
									<div class="bullet-margin"><i class="fas" :class="getStringIconClass(newPlan, currentPlanCopy)"></i></div>
									<div class="bullet-content">{{newPlan.details.sharingType.displayValue}}</div>
								</li>
								<li v-if="plan.details.accessKeyLimit" class="bullet">
									<div class="bullet-margin"><i class="fas" :class="getNumberIconClass(newPlan, currentPlanCopy)"></i></div>
									<div class="bullet-content">{{newPlan.details.accessKeyLimit.displayValue}}</div>
								</li>
							</ul>
							<ul v-else class="plan-features">
								<li v-if="plan.details.storageSizeLimit" class="bullet">
									<div class="bullet-margin"><i class="fas fa-check"></i></div>
									<div class="bullet-content">{{plan.details.storageSizeLimit.displayValue}}</div>
								</li>
								<li v-if="plan.details.sharingType" class="bullet">
									<div class="bullet-margin"><i class="fas fa-check"></i></div>
									<div class="bullet-content">{{plan.details.sharingType.displayValue}}</div>
								</li>
								<li v-if="plan.details.accessKeyLimit" class="bullet">
									<div class="bullet-margin"><i class="fas fa-check"></i></div>
									<div class="bullet-content">{{plan.details.accessKeyLimit.displayValue}}</div>
								</li>
							</ul>
							<div class="column separated-extra bottom" v-if="plan.active">
								<a target="_blank" class="button flexible" v-if="plan.contactForPricing" href="https://help.tekcloud.com/hc/en-us/requests/new?tf_subject=TekDrive%20Ultimate%20plan">Contact for pricing</a>
								<label v-else v-for="(cycle, index) in plan.billingIntervals" v-bind:key="index" class="button flexible relative" :class="{disabled: processing || inputDisabled(cycle), single: plan.billingIntervals.length === 1, new: cycle.intervalId === selection.intervalId, active:  (cycle.intervalId === selection.intervalId || cycle.intervalId === currentPlan.intervalId), success: cycle.hasTrial}">
									<small class="badge badge-success annual" v-if="cycle.interval === 'yearly'">Save 16%</small>
									<input type="radio" hidden :disabled="processing || inputDisabled(cycle)" v-model="selectedId" @change="selectNewPlan(cycle)" name="plan" :value="cycle.intervalId" @click="onButtonClick">
									<div v-if="cycle.hasTrial">{{TRIAL_DAYS}}-day trial</div>
									<div v-else-if="cycle.amount === 0">Free</div>
									<div v-else-if="cycle.amount > 0" >{{cycle.amount | currency(true) || 0}} {{cycle.displayInterval}}</div>
								</label>
							</div>
						</div>
					</section>
					<footer class="column separated-extra" v-if="newPlan">
						<payment-notice
							class="below"
							v-if="paymentRequired"
							:trial="trialExpiry"
							:on-click="onPaymentClick"
							:returnPath="'/subscriptions/drive'"
							:model="account.paymentMethod"
							:is-dirty="isDirty"
							:loading="!paymentMethodLoaded">
						</payment-notice>

						<estimated-cost :loading="loadingTaxInfo" v-if="selectionCost" :cost="estimatedCost"></estimated-cost>

						<div v-if="changeSubscriptionError" class="row rigid">
							<div class="notice error gap">
								<!-- <button type="button" class="close link" @click="removeNotices">×</button> -->
								<div v-if="changeSubscriptionError.type === 'StripeCardError'">
									{{changeSubscriptionError.message}}
								</div>
								<div v-else-if="changeSubscriptionError.type === 'PAYMENT_GATEWAY_ERROR'">
									There was an error processing your transaction.
								</div>
								<div v-else>
									There was an error updating your subscription.
								</div>
							</div>
						</div>

						<!-- </footer> -->
						<footer class="row flexible separated-extra right">
							<button @click="resetState" type="button" class="flexible">Cancel</button>
							<button :disabled="submitDisabled" type="submit" :class="{success: newPlan.hasTrial}" class="primary flexible">
								<span v-if="submitting"><i class="fas fa-spinner fa-spin"></i></span>
								<span v-else-if="estimatedCost">Pay {{estimatedCost.total | currency(true)}}</span>
								<span v-else-if="newPlan.hasTrial">Start {{TRIAL_DAYS}}-Day Trial</span>
								<span v-else-if="!current">Subscribe</span>
								<span v-else>Confirm Change</span>
							</button>
						</footer>
					</footer>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import capitalize from '../filters/capitalize';
import currency from '../filters/currency';
import byte from '../filters/byte';
import date from '../filters/date';
import { scrollTo } from '../directives/scroll-to';
import PaymentNotice from '../components/PaymentNotice';
import ToggleSwitch from '@/components/ToggleSwitch';
import EstimatedCost from '@/components/EstimatedCost';
import taxUtil from '@/modules/tax-util';
import Popover from '../components/Popover';
import Spinner from '../components/Spinner';
import PlanCardPlaceholder from '../components/PlanCardPlaceholder';
import H1Placeholder from '../components/H1Placeholder';
import H2Placeholder from '../components/H2Placeholder';
import TablePlaceholder from '../components/TablePlaceholder';
import TrialBadge from '@/components/TrialBadge';
import Actions from '../components/Actions';
import { mapGetters, mapState, mapActions } from 'vuex';
import accountService from '@/modules/account-service';
import Vue from 'vue';
import ENV_VARS from '@/modules/env-vars.js';

export default {
	name: 'DriveSubEdit',
	filters: {
		currency,
		date,
		capitalize,
		byte
	},
	directives: {
		scrollTo
	},
	components: {
		PaymentNotice,
		Spinner,
		PlanCardPlaceholder,
		H1Placeholder,
		H2Placeholder,
		TablePlaceholder,
		Popover,
		TrialBadge,
		ToggleSwitch,
		EstimatedCost
	},
	data() {
		return {
			selection: {},
			touched: false,
			previousIntervalId: null,
			submitting: false,
			toggling: false,
			currentPlan: null,
			selectedId: null,
			plans: [],
			subscriptionLoading: false,
			getSubscriptionError: null,
			changeSubscriptionError: null,
			showConfirmation: false,
			TRIAL_DAYS: ENV_VARS.TRIAL_DAYS
		};
	},
	computed: {
		...mapGetters({
			address: 'address',
			account: 'account',
			accountStatus: 'accountStatus',
			isUserLoaded: 'isUserLoaded',
			driveAppUrl: 'auth/driveAppUrl',
		}),
		...mapState('drive', {
			intervalOptions: 'intervalOptions',
			storedSelection: 'selection',
			subRenews: 'subscriptionRenews',
			current: 'currentSubscription',
			planCards: 'planCards',
			reviewPlanCards: 'reviewPlanCards',
			plansMap: 'mappedPlans',
			newPlan: 'newPlan',
			currentPlanCopy: 'currentPlanCopy',
			// estimatedCost: 'estimatedCost'
		}),
		...mapState('subscription', {
			redirectToDrive: 'redirectToDrive'
		}),
		...mapState('auth', [
			'refreshToken'
		]),
		...mapState({
			estimatedTax(state) {
				return state.account.estimatedTax;
			},
			loadingTaxInfo(state) {
				return state.account.loadingTaxInfo;
			},
		}),
		estimatedCost() {
			// wait for a new plan and estimatedTax before calculating
			return this.newPlan && this.estimatedTax ? taxUtil.calculateTax(this.newPlan.amount, this.estimatedTax.taxRatePercentage) : null;
		},
		paymentRequired(){
			return this.newPlan && this.newPlan.paymentMethodRequired && !this.newPlan.hasTrial;
		},
		showTrialButton(){
			return this.newPlan.hasTrial && !this.trialOptOut;
		},
		preselectedPlanId(){
			return this.$route.query.plan && this.$route.query.plan;
		},
		showOnboardingFlow() {
			return this.redirectToDrive || (!this.current && this.subscriptionLoading);
		},
		onboardingPlan(){
			return (this.showOnboardingFlow || !this.currentPlan) && this.newPlan;
		},
		currentPlanId(){
			return this.currentPlan && this.currentPlan.id;
		},
		selectionId(){
			return this.selection && this.selection.id;
		},
		currentPlanName(){
			return this.currentPlan && this.currentPlan.name;
		},
		newPlanId(){
			return this.newPlan && this.newPlan.id;
		},
		newPlanName(){
			return this.newPlan && this.newPlan.name;
		},
		selectionCost() {
			let selection = this.newPlan || this.currentPlan;

			if (!selection || !selection.amount) {
				return 0;
			}
			return selection.amount;
		},
		trial() {
			if (!this.currentTrial) {
				return false;
			}
			const now = new Date();
			const trialExpiry = new Date(this.currentTrial.expiry);
			const daysLeft = Math.round((trialExpiry - now) / (1000 * 60 * 60 * 24));
			return {
				daysLeft: daysLeft,
				expiry: this.expiry,
				oneDayLeft: daysLeft === 1,
				lastDay: daysLeft === 0
			};
		},
		isDirty() {
			return this.newPlanSelected && this.touched;
		},
		drivePlansUrl() {
			return ENV_VARS.DRIVE_PUBLIC_URL + '#pricing';
		},
		isYearly() {
			return this.selection.interval === 'yearly';
		},
		hidePlanControlsRow(){
			return this.selection.isInternalFreePlan;
		},
		newTrial() {
			return this.newPlan && this.newPlan.hasTrial;
		},
		trialEligible() {
			return this.selection.actualInterval !== 'free' && this.current && this.current.trialExpiry;
		},
		trialExpiry() {
			const now = new Date();
			const startDate = new Date(now);
			return this.selectionIsCurrentTrial ? new Date(this.current.expiry) : this.selection.isTrial ? new Date(startDate.setDate(startDate.getDate() + this.TRIAL_DAYS)) : null;
		},
		selectionIsCurrentTrial() {
			return this.selection.isCurrent && this.current.isTrial;
		},
		selectionIsTrial() {
			return this.selectionIsCurrentTrial || this.selection.isTrial;
		},
		submitDisabled() {
			return this.processing || (this.paymentRequired && !this.account.paymentMethod);
		},
		processing() {
			return this.subscriptionLoading || this.submitting;
		},
		showPlanLoader() {
			return this.subscriptionLoading && this.plans.length === 0;
		},
		paymentMethodLoaded() {
			return this.account.paymentMethod !== undefined;
		},
		redirectReason() {
			return this.$route.query && this.$route.query.r;
		},
		credit() {
			return this.account.balanceCents;
		}
	},
	methods: {
		...mapActions('subscription', {
			clearStoredSelection: 'CLEAR_SELECTION',
		}),
		selectCurrentPlan(current, old){
			if (!current) {
				return;
			};
			const currentPlanFromSub = current && current.plan;
			const currentPlan = this.plansMap[currentPlanFromSub.intervalId];
			this.currentPlan = currentPlan;
			this.setSelection(currentPlan);

			if (this.preselectedPlanId) {
				this.selectPreselectedPlan();
			}
		},
		prepareReview(plan){
			var newPlan = this.planCards.find(reducedPlan => reducedPlan.name === plan.name);
			var currentPlan = this.currentPlan ? this.planCards.find(reducedPlan => reducedPlan.name === this.currentPlan.name) : null;
			// trim plans down for review
			this.plans = [newPlan];

			if (this.showOnboardingFlow || !currentPlan || currentPlan.name === newPlan.name) {
				// only show new plan in this case
				return;
			}
			// add current plan for comparison
			this.plans.unshift(currentPlan);
		},
		selectNewPlan(plan) {
			if (!this.newPlan) {
				this.prepareReview(plan);
			}
			this.$store.dispatch('drive/SET_NEW_PLAN', { plan, currentPlan: this.currentPlan, reviewPlanCards: this.plans });
			this.setSelection(plan);
		},
		isNewPlan(plan) {
			return this.currentPlan && this.newPlan && this.newPlan.name === plan.name;
		},
		setSelection(selection){
			this.selection = selection;
		},
		onPaymentClick(){
			return null;
		},
		inputDisabled(cycle){
			return (cycle.intervalId === this.currentPlan.intervalId) || (cycle.name === this.currentPlanName && this.newPlan && this.newPlan.intervalId !== cycle.intervalId);
		},
		inputHidden(cycle){
			return (cycle.name === this.currentPlanName && this.newPlan && this.newPlan.id !== cycle.id);
		},
		getNumberIconClass(newPlan, currentPlan) {
			return !currentPlan || (newPlan.details.storageSizeLimit.value > currentPlan.details.storageSizeLimit.value) ?
				'fa-arrow-up success' : (newPlan.details.storageSizeLimit.value < currentPlan.details.storageSizeLimit.value) ?
					'fa-arrow-down error' : 'fa-check';
		},
		getStringIconClass(newPlan, currentPlan) {
			return (!currentPlan || newPlan.details.sharingType.value === 'UNLIMITED' && currentPlan.details.sharingType.value === 'PERMISSIONS_LIMITED') ?
				'fa-arrow-up success' : newPlan.details.sharingType.value === 'PERMISSIONS_LIMITED' && currentPlan.details.sharingType.value === 'UNLIMITED' ?
					'fa-arrow-down error' : 'fa-check';
		},
		deepCopy(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		clearRouteParams(){
			this.$router.replace({query: null});
		},
		getPlanByIntervalId(intervalId) {
			return this.deepCopy(this.plans).find(plan => {
				return plan.intervalId === intervalId;
			});
		},
		getPlanById(id) {
			return this.deepCopy(this.plans).find(plan => {
				return plan.id === id;
			});
		},
		getInterval(plan) {
			return (!plan.interval || plan.interval === 'free') ? 'monthly' : plan.interval;
		},
		onButtonClick() {
			this.touched = true;
			this.removeNotices();
		},
		onRenewalChange(val) {
			this.$store.dispatch('drive/SET_RENEWAL_FLAG', val);

			if (this.newPlan) {
				return;
			}

			this.toggling = true;

			const patchObj = {};
			if (this.current.isPromo || this.current.isTrial) {
				patchObj.transitionAtEnd = val;
			} else {
				patchObj.cancelAtPeriodEnd = !val;
			}

			this.updateSubscription(patchObj)
				.catch(reason => {
					this.$store.dispatch('drive/SET_RENEWAL_FLAG', !val);
				})
				.finally(()=>{
					this.toggling = false;
				});
		},
		onSubmitPlan() {
			if (this.current && this.newPlan && !this.newPlan.hasTrial) {
				const patchObj = {
					interval: this.newPlan.interval,
					id: this.newPlan.id,
					cancelAtPeriodEnd: !this.subRenews
				};

				this.updateSubscription(patchObj)
					.then(() => {
						// redirect to drive app as part of the registration flow
						if (this.redirectToDrive) {
							window.location.href = this.driveAppUrl + '&r=newuser';
						}
						return this.$store.dispatch('auth/SET_REFRESH_TOKEN', this.refreshToken).then(() => {
							this.leavePlan();
						});
					})
					.catch(error => {
						this.changeSubscriptionError = error;
					});
			} else {
				this.createSubscription();
			}
		},
		updateSubscription(payload) {
			this.submitting = true;

			const patchObj = payload;
			patchObj.subId = this.current.id;

			return this.$store.dispatch('drive/CHANGE_SUBSCRIPTION_REQUEST', patchObj).then(() => {
				this.submitting = false;
				return Promise.resolve();
			}).catch((error) => {
				this.submitting = false;
				return Promise.reject(error);
			});
		},
		createSubscription(payload) {
			this.submitting = true;

			let subObj = {};
			// send original trial id here (_monthly > _trial)-- hopefully trials will get their own plans
			let trialId = this.newPlan.hasTrial && this.newPlan.id.replace('trial', this.newPlan.interval);
			subObj = {
				interval: this.newPlan.interval,
				id: trialId || this.newPlan.id,
				trial: this.newPlan.hasTrial
			};

			this.$store.dispatch('drive/ADD_SUBSCRIPTION_REQUEST', subObj).then(() => {
				this.touched = false;

				if (this.redirectToDrive) {
					window.location.href = this.driveAppUrl + '&r=newuser';
				}

				return this.$store.dispatch('auth/SET_REFRESH_TOKEN', this.refreshToken).then(() => {
					this.leavePlan();
				});
			}).catch((error) => {
				this.submitting = false;
			});
		},
		leavePlan() {
			this.resetState();
			this.$store.dispatch('drive/TEAR_DOWN');
			this.$router.push('/');
		},
		resetState() {
			this.$store.dispatch('drive/RESET_STATE');
			this.plans = this.planCards;
			this.selectedId = null;
			this.setSelection(this.currentPlan);
			if (Object.entries(this.$route.query).length) {
				this.clearRouteParams();
			}
		},
		resetCouponState() {
			this.couponDetails = null;
			this.couponDetailsError = null;
			this.couponCodeModel = null;
		},
		restoreSubscriptionState() {
			// load initial plan options
			this.$store.dispatch('subscription/RESET_PLANS_STATE');
			this.resetCouponState();
		},
		removeNotices() {
			// remove notices to clean up view
			this.$store.dispatch('subscription/RESET_CHANGE_SUBSCRIPTION_STATUS');
			this.showRemoveNotice = false;
		},
		selectPreselectedPlan() {
			// adding trial to plan id until we figure out more about trial plans
			const preselectedPlan = this.plansMap[this.preselectedPlanId];

			// preslecting the same plan is like inception
			if (this.redirectToDrive && preselectedPlan.id === this.currentPlan.id) {
				window.location.href = this.driveAppUrl + '&r=newuser';
			}

			if (preselectedPlan) {
				this.selectNewPlan(preselectedPlan);
			}
		},
	},
	watch: {
		current: {
			handler: 'selectCurrentPlan',
			immediate: true
		}
	},
	created() {
		let vm = this;
		vm.subscriptionLoading = true;
		vm.$store.dispatch('drive/GET_SUBSCRIPTION_REQUEST',  { subId: vm.$route.params.subId })
			.then(()=>{
				vm.subscriptionLoading = false;
				vm.plans = vm.reviewPlanCards || vm.planCards;
			})
			.catch(error => {
				vm.subscriptionLoading = false;
				vm.getSubscriptionError = error;
			});
		if (!vm.redirectToDrive) {
			vm.$store.dispatch('subscription/SET_DRIVE_REDIRECT', !!vm.preselectedPlanId);
		}
		// watching for an inactive plan to be added to plans
		var unwatchPlanCards = this.$watch('planCards', (newVal) => {
			if (vm.currentPlan && vm.currentPlan.active) {
				return;
			}
			const inactivePlan = newVal.find(item => item.active === false);
			if (inactivePlan) {
				vm.plans = newVal;
				//remove watcher now
				unwatchPlanCards();
			}
		});
	}
};
</script>



// WEBPACK FOOTER //
// ./src/views/DriveSubEdit.vue